// extracted by mini-css-extract-plugin
export var avatar = "_rs-3";
export var avatarContainer = "_rs-2";
export var avatarSpacer = "_rs-5";
export var avatarSpacerContainer = "_rs-4";
export var avatarStackContainer = "_rs-1";
export var bubble = "_rs-0";
export var remainderBubble = "_rs-6";